import React from 'react';
import { Status, OUTPUT, } from '../../types/searchTypes';
export const DatasetSelectionCtx = React.createContext({
    datasetCollection: [],
    selectDatasets: () => { }, // no-op
});
export const FileSelectionCtx = React.createContext({
    fileCollection: [],
    selectFiles: () => { }, // no-op
});
export const NotebookFeedbackCtx = React.createContext({});
export const UserCtx = React.createContext({});
export const emptyFileSelection = [];
export const emptyDatasetSelection = [];
export const DatasetSelectionProvider = ({ children }) => {
    const [datasetCollection, selectDatasets] = React.useState(emptyDatasetSelection);
    const value = React.useMemo(() => ({
        datasetCollection,
        selectDatasets,
    }), [datasetCollection, selectDatasets]);
    return (React.createElement(DatasetSelectionCtx.Provider, { value: value }, children));
};
export const FileSelectionProvider = ({ children }) => {
    const [fileCollection, selectFiles] = React.useState(emptyFileSelection);
    const value = React.useMemo(() => ({
        fileCollection,
        selectFiles,
    }), [fileCollection, selectFiles]);
    return (React.createElement(FileSelectionCtx.Provider, { value: value }, children));
};
export const notebookDefaultProperties = {
    dialogOpen: false,
    output: OUTPUT.NA,
    processingStatus: Status.IDLE,
    redirectUrl: '',
    workerNumber: 0,
};
export const NotebookPropertiesProvider = ({ children, }) => {
    const [notebookProperties, setNotebookProperties] = React.useState(notebookDefaultProperties);
    const value = React.useMemo(() => ({
        notebookProperties,
        setNotebookProperties,
    }), [notebookProperties, setNotebookProperties]);
    return (React.createElement(NotebookFeedbackCtx.Provider, { value: value }, children));
};
export const UserProvider = ({ children }) => {
    const [user, setUser] = React.useState({});
    const value = React.useMemo(() => ({
        user,
        setUser,
    }), [user, setUser]);
    return React.createElement(UserCtx.Provider, { value: value }, children);
};
